import { Box, Text, Wrap, WrapItem } from '@chakra-ui/react'

const SUGGESTED_QUESTIONS_LABEL = 'SUGGESTED QUESTIONS'

interface SuggestedQuestionsIProps {
  questions: string[]
  onSelect: (question: string) => void
  isDisabled?: boolean
}

export const SuggestedQuestions = ({
  questions,
  onSelect,
  isDisabled,
}: SuggestedQuestionsIProps) => {
  if (!questions.length) return null

  return (
    <Box>
      <Text color='text.tertiary.light' fontSize='11px' fontWeight={600} mb={2}>
        {SUGGESTED_QUESTIONS_LABEL}
      </Text>
      <Wrap spacing={2}>
        {questions.map((q, idx) => (
          <WrapItem key={idx}>
            <Box
              _hover={{
                bg: isDisabled ? 'bg.300' : 'bg.200',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
              bg='bg.300'
              borderRadius='full'
              color='link.100'
              fontSize='13px'
              fontWeight={500}
              onClick={() => !isDisabled && onSelect(q)}
              opacity={isDisabled ? 0.6 : 1}
              px={3}
              py='6px'
              transition='background 0.15s'
            >
              {q}
            </Box>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  )
}
